import { action } from "satcheljs";

import type { OwaNovaActionUnion } from "../types";

export const onExportContacts = action("onExportContacts", event => ({
    event,
    owaType: "exportContacts",
})) as OwaNovaActionUnion<"exportContacts">;
